import ThisModule from "./AlertProvider";

export default ThisModule;
